import { useState, useEffect } from 'react';
import { missionApi } from '../../api/mission.api';
import { useWorkspaceNav } from '../../store/WorkspaceContext';
import { Skeleton, EmptyState, Badge } from '../ui/index';
import { timeAgo } from '../../utils/persianNumber';
import { Buildings, Car, HourglassMedium } from '@phosphor-icons/react';

// Shared between MyMissionsPage (its own sidebar entry, for
// manager_employee/dispatcher) and UserDashboard's "ماموریت‌ها" tab (for
// simple_employee) - same list, two places to reach it from.
export default function MissionsList() {
  const workspaceNav = useWorkspaceNav();
  const [missions, setMissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    missionApi.getMyMissions().then(r => setMissions(Array.isArray(r.data) ? r.data : [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {[1, 2, 3].map(k => <Skeleton key={k} h={70} radius={12} />)}
      </div>
    );
  }
  if (missions.length === 0) {
    return <EmptyState icon={<Car size={44} weight="regular" />} title="ماموریتی برای شما تعریف نشده است" />;
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {missions.map((m) => (
        <div key={m.mission_id} onClick={() => m.ticket_id && workspaceNav(`/missions/${m.ticket_id}/respond`, m.ticket_title || 'ماموریت')}
          className="pj-card-hover" style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: '16px 20px', cursor: m.ticket_id ? 'pointer' : 'default', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#0f172a', marginBottom: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {m.ticket_title || 'بدون عنوان'}
            </div>
            <div style={{ fontSize: 12, color: '#64748b', display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              {m.company_name && <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}><Buildings size={12} weight="regular" /> {m.company_display || m.company_name}</span>}
              {m.destination && <span>📍 {m.destination}</span>}
              {m.mission_date && <span>🕒 {timeAgo(m.mission_date)}</span>}
            </div>
          </div>
          <div style={{ display: 'flex', gap: 6, flexShrink: 0, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
            {m.responsed && <Badge variant="green">✅ پاسخ داده شده</Badge>}
            {m.approval_status === 'approved' && <Badge variant="green">✔️ تایید OTP</Badge>}
            {m.approval_status === 'pending_otp' && <Badge variant="amber"><HourglassMedium size={11} weight="regular" /> OTP</Badge>}
            {m.approval_status === 'no_recipient' && <Badge variant="gray">بدون مسئول</Badge>}
            <Badge variant={m.is_active ? 'blue' : 'gray'}>{m.is_active ? 'در حال انجام' : 'پایان‌یافته'}</Badge>
          </div>
        </div>
      ))}
    </div>
  );
}
